// Webpack Imports
import * as bootstrap from 'bootstrap';


( function () {
	'use strict';

	jQuery(document).ready(function($) {
    $('.squad-carousel').slick({
			slidesToShow: 3,
			slidesToScroll: 3,
			infinite: true,
			centerMode: true,
			responsive: [
				{
					breakpoint: 960,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
					}
				}
			]
			// variableWidth: true
		});
	});

	// Focus input if Searchform is empty
	[].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
		el.addEventListener( 'submit', function ( e ) {
			var search = el.querySelector( 'input' );
			if ( search.value.length < 1 ) {
				e.preventDefault();
				search.focus();
			}
		} );
	} );

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
	var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
		return new bootstrap.Popover( popoverTriggerEl, {
			trigger: 'focus',
		} );
	} );
} )();